function setupPersonalization() {

  const input = document.querySelector('#custom-name-input');
  const mediaWrapper = document.querySelector('.product__media-wrapper');

  if (!input || !mediaWrapper) return;

  // 🔥 remove old overlay (prevents duplicates)
  let existing = document.getElementById('name-preview');
  if (existing) existing.remove();

  // 🔥 create overlay
  const overlay = document.createElement('div');
  overlay.id = 'name-preview';
  overlay.style.position = 'absolute';
  overlay.style.top = '55%';
  overlay.style.left = '20%';
  overlay.style.transform = 'rotate(-90deg)';
  overlay.style.fontSize = '22px';
  overlay.style.fontWeight = '500';
  overlay.style.color = 'black';
  overlay.style.zIndex = '9999';
  overlay.style.pointerEvents = 'none';

  // make wrapper relative
  mediaWrapper.style.position = 'relative';
  mediaWrapper.appendChild(overlay);

  // 🔥 update text
  input.addEventListener('input', function (e) {
    e.stopPropagation();
    overlay.innerText = input.value;
  });

}

/* 🔥 RUN MULTIPLE TIMES (Dawn fix) */
document.addEventListener('DOMContentLoaded', setupPersonalization);
document.addEventListener('shopify:section:load', setupPersonalization);

/* 🔥 EXTRA: detect DOM changes (THIS is the real fix) */
const observer = new MutationObserver(() => {
  setupPersonalization();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('custom-name');
  const preview = document.getElementById('preview-text');

  if (input && preview) {
    input.addEventListener('input', function () {
      preview.textContent = input.value;
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const input = document.getElementById('custom-name');
  const previewBtn = document.querySelector('.preview-btn');
  const stickyBtn = document.querySelector('.preview-btn-sticky');

  const modal = document.getElementById('preview-modal');
  const closeBtn = document.querySelector('.preview-close');
  const overlay = document.querySelector('.preview-overlay');

  const modalText = document.getElementById('modal-preview-text');
  const modalImg = document.getElementById('modal-preview-image');

  const addToCartBtn = document.querySelector('.preview-add-to-cart');

  if (!input || !previewBtn || !modal) return;

  // OPEN MODAL
  const openModal = function () {
    let value = input.value.trim();

    modalText.textContent = value;
    modal.style.display = 'block';

    // 👉 ADD BLUR + LOCK SCROLL
    document.body.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
  };

  previewBtn.addEventListener('click', openModal);
  stickyBtn?.addEventListener('click', openModal);

  // CLOSE
  function closeModal() {
    modal.style.display = 'none';

    // 👉 REMOVE BLUR + UNLOCK SCROLL
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
  }

  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);

  // ESC KEY CLOSE (nice UX)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // VARIANT IMAGE SYNC
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;

    if (variant?.featured_image && modalImg) {
      modalImg.src = variant.featured_image.src;
    }
  });

  // ADD TO CART FROM POPUP
  addToCartBtn?.addEventListener('click', function () {
    document.querySelector('form[action="/cart/add"]')?.submit();
  });

});
document.addEventListener('change', function (e) {
  if (!e.target.matches('input[name^="options"]')) return;

  const form = e.target.closest('form');
  if (!form) return;

  const selectedOptions = Array.from(
    form.querySelectorAll('input[name^="options"]:checked')
  ).map(input => input.value);

  const variants = window.productVariants || [];

  const found = variants.find(variant =>
    variant.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!found) return;

  // update variant ID
  form.querySelector('[name="id"]').value = found.id;

  // 🔥 trigger Dawn system
  const variantSelects = document.querySelector('variant-selects');

  if (variantSelects) {
    variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // custom event (for your popup)
  document.dispatchEvent(new CustomEvent('variant:change', {
    detail: { variant: found }
  }));

  // fallback image switch
  if (found.featured_media) {
    const mediaId = found.featured_media.id;

    document.querySelectorAll('[data-media-id]').forEach(el => {
      el.classList.remove('is-active');

      if (el.dataset.mediaId == mediaId) {
        el.classList.add('is-active');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {

  function removeFromText() {
    document.querySelectorAll('.price-item').forEach(function (el) {
      el.textContent = el.textContent.replace('From ', '').trim();
    });
  }

  removeFromText();

  setInterval(removeFromText, 500);
});

let lastScrollY = window.scrollY;
document.addEventListener('scroll', function () {
  const header = document.querySelector('sticky-header.header-wrapper');
  const stickyWrapper = document.querySelector('.sticky-button-wrapper');
  const currentScrollY = window.scrollY;

  if (currentScrollY > 10) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }

  if (stickyWrapper) {
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // Scrolling down and past threshold -> Show
      stickyWrapper.classList.add('is-visible');
    } else if (currentScrollY < lastScrollY) {
      // Scrolling up -> Hide
      stickyWrapper.classList.remove('is-visible');
    }
  }

  lastScrollY = currentScrollY;
});